interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

// PWA Service Worker Registration
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const isDev = import.meta.env?.NODE_ENV === 'development';
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        if (isDev) {
          console.info('SW registered:', registration);
        }
        registration.update();
      })
      .catch((registrationError) => {
        if (isDev) {
          console.warn('SW registration failed:', registrationError);
        }
      });
  });
}

// PWA Install Prompt
export function setupPWAInstallPrompt() {
  let deferredPrompt: BeforeInstallPromptEvent | null = null;

  window.addEventListener('beforeinstallprompt', (event: Event) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    event.preventDefault();
    // Stash the event so it can be triggered later (after a user action)
    deferredPrompt = event as BeforeInstallPromptEvent;
    
    // Show install button or banner
    showInstallPrompt();
  });

  function showInstallPrompt() {
    // You can show a custom install button here
    if (deferredPrompt) {
      console.log('PWA install prompt available');
    }
  }

  // Handle install button click
  window.addEventListener('appinstalled', () => {
    console.log('PWA was installed');
    deferredPrompt = null;
  });
}

// PWA Display Mode Detection
export function isStandaloneMode(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone === true;
}

// PWA Status Bar Styling
export function setupStatusBarStyling() {
  if (isStandaloneMode()) {
    // Add class to body for standalone mode styling
    document.body.classList.add('pwa-standalone');
    
    // Set status bar color
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#3F8CFF');
    }
  }
}
